import { useCallback } from "react";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { urlReplacer } from "../../../utils";

export default function () {
  const { request } = useApi();

  return {
    create: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CREATE_PROGRAM_HIGHER,
        });
      },
      [request],
    ),

    clone: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CLONE_PROGRAM_HIGHER,
        });
      },
      [request],
    ),

    update: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "PUT",
          url: ApiRoutes.CREATE_PROGRAM_HIGHER,
        });
      },
      [request],
    ),

    checkDuplication: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: `${urlReplacer(ApiRoutes.CHECK_PROGRAM_DUPLICATION_HIGHER, {
            id: data.academicId,
          })}`,
        });
      },
      [request],
    ),

    activate: useCallback(
      async (id) => {
        return request({
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.ACTIVATE_PROGRAM_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    deactivate: useCallback(
      async (id, data) => {
        return request({
          data: data,
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.DEACTIVATE_PROGRAM_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    fetchAppCount: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${
            ApiRoutes.GET_APPLICATION_COUNT_FOR_DEACTIVATION_HIGHER +
            stringify(filter)
          }`,
        });
      },
      [request],
    ),

    activateIntake: useCallback(
      async (id) => {
        return request({
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.ACTIVATE_INTAKE_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    deactivateIntake: useCallback(
      async (id, data) => {
        return request({
          data: data,
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.DEACTIVATE_INTAKE_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    deleteOneIntake: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_INTAKE_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    deleteOne: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_PROGRAM_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    fetchAll: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${ApiRoutes.PROGRAMS_HIGHER + stringify(filter)}`,
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_PROGRAM_HIGHER, { id })}`,
        });
      },
      [request],
    ),

    uploadDetailFile: useCallback(
      (file) => {
        let formData = new FormData();
        formData.append("file", file);
        return request({
          method: "POST",
          url: `${ApiRoutes.UPLOAD_PROGRAM_DETAIL_FILE}`,
          data: formData,
        });
      },
      [request],
    ),

    fetchCountriesContainingPrograms: useCallback(() => {
      return request({
        method: "GET",
        url: `${ApiRoutes.GET_COUNTRIES_CONTAINING_PROGRAMS_HIGHER}`,
      });
    }, [request]),

    fetchViewMore: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_VIEW_MORE_PROGRAM_HIGHER, { id })}`,
        });
      },
      [request],
    ),
  };
}
